import { createSelector } from 'reselect';
import { prop } from 'ramda';

import { selectFooter } from '../contentRegistry';
import { selectIsKioskMode } from '../kiosk';
import { selectIsBookingActive } from '../booking';

export const selectFooterLinks = createSelector(
  selectFooter,
  prop('links')
);

export const selectFooterStoreIcon = createSelector(
  selectFooter,
  prop('storeIcon')
);

export const selectFooterStoreLink = createSelector(
  selectFooter,
  prop('storeUrl')
);

export const selectFooterDisclaimer = createSelector(
  selectFooter,
  prop('infoDisclaimer')
);

export const selectFooterCopyright = createSelector(
  selectFooter,
  prop('copyrightInfo')
);

export const selectIsFooterVisible = createSelector(
  selectIsKioskMode,
  selectIsBookingActive,
  (isKiosk, isBooking) => !isKiosk && !isBooking
);
